import { ArrowRight } from "lucide-react";
import { SITE } from "../../data/site";
import { LeafSprig } from "../Ornaments";

export function Supporters() {
  return (
    <section className="support" aria-labelledby="support-title">
      <div className="container">
        <div className="support-frame">
          <div className="support-label">
            <LeafSprig className="support-leaf" />
            <h2 id="support-title">Supported by</h2>
          </div>
          <span className="support-divider" aria-hidden="true" />
          {/* Original Adani Foundation logo file */}
          <img
            className="support-logo"
            src="/images/adani-foundation-logo.png"
            alt="Adani Foundation"
            width={213}
            height={140}
            loading="lazy"
          />
          <span className="support-divider" aria-hidden="true" />
          <p className="support-text">
            The Adani Foundation has been instrumental in supporting our mission
            to digitize, preserve, and share the Jain heritage.
          </p>
          <a
            href={SITE.adaniUrl}
            target="_blank"
            rel="noreferrer"
            className="btn btn-outline support-btn"
          >
            About Support
            <ArrowRight aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}
